import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from "./authentication/authentication.service";
import { LoggingService } from "./logging/logging.service";
import { LazyLoadEvent } from "../models/DataTables/lazyLoadEvent";
import { Campaign, CreateCampaignModel, EditCampaignModel, CampaignSlideModel, CampaignSlide, CampaignDisplay } from "../models/inModels/campaign";


@Injectable()
export class CampaignService {
	private route = '/api/campaigns';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }


	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/search`, event, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<CampaignDisplay> {
		return this.http.get(`${this.auth.apiUrl}${this.route}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as CampaignDisplay)
			.catch(error => this.logging.handleError(error));
	}

	create(user: CreateCampaignModel): Promise<Campaign> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/create`, user, { headers: this.auth.header })
			.toPromise()
			.then(response => response as Campaign)
			.catch(error => this.logging.handleError(error));
	}

	update(user: EditCampaignModel): Promise<Campaign> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/update`, user, { headers: this.auth.header })
			.toPromise()
			.then(response => response as Campaign)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: number): Promise<any> {
		return this.http.delete(`${this.auth.apiUrl}${this.route}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	addSlide(user: CampaignSlideModel): Promise<CampaignSlide> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/slides/create`, user, { headers: this.auth.header })
			.toPromise()
			.then(response => response as CampaignSlide)
			.catch(error => this.logging.handleError(error));
	}

	updateSlide(user: CampaignSlideModel): Promise<CampaignSlide> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/slides/update`, user, { headers: this.auth.header })
			.toPromise()
			.then(response => response as CampaignSlide)
			.catch(error => this.logging.handleError(error));
	}

	deleteSlide(user: CampaignSlideModel): Promise<CampaignSlide> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/slides/delete`, user, { headers: this.auth.header })
			.toPromise()
			.then(response => response as CampaignSlide)
			.catch(error => this.logging.handleError(error));
	}

	getDropdown(event): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/dropdown/locations`,JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getDropdownTypes(event): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/dropdown/persist/types`,JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/campaign.service.ts